import React from "react";
import { FaPhoneAlt, FaChevronRight } from "react-icons/fa";

const TravelPortalSupport = () => {
    return (
        <a href="https://wa.me/19134133300" target="_blank" className="travel-support-widget">
            <div className="travel-support-widget-left">
                <FaPhoneAlt className="icon" />
            </div>
            <div className="travel-support-widget-center">
                <h4>Travel Portal Support</h4>
                <p>Call our support team</p>
            </div>
            <div className="travel-support-widget-right">
                <FaPhoneAlt className="icon" />
            </div>
        </a>
    );
};

export default TravelPortalSupport;
